<section class="mod-page ntf-page" data-module="notifications">
  <header class="page-header">
    <div>
      <p class="eyebrow">Notifications</p>
      <h1>Grievance alerts</h1>
    </div>
    <div class="ntf-header-actions">
      <p class="ntf-unread">{{ unreadCount() }} unread</p>
      <button
        type="button"
        class="ntf-mark-all"
        [disabled]="unreadCount() === 0 || busy()"
        (click)="markAllRead()"
      >
        {{ busy() ? 'Marking…' : 'Mark all as read' }}
      </button>
      <button
        type="button"
        class="ntf-delete-all"
        [disabled]="items().length === 0 || busy()"
        (click)="deleteAll()"
      >
        Delete all
      </button>
    </div>
  </header>

  <app-toast
    [message]="message()"
    [tone]="messageTone()"
    (dismissed)="message.set(null)"
  />


  <div class="ntf-bar">
    <div class="ntf-toggles">
      <button type="button" class="ntf-tog" [class.on]="filter() === 'All'" (click)="filter.set('All')">All</button>
      <button type="button" class="ntf-tog" [class.on]="filter() === 'Unread'" (click)="filter.set('Unread')">
        Unread
      </button>
    </div>
  </div>

  @if (!isDm()) {
    <div class="ntf-chips">
      @for (c of categories; track c) {
        <button
          type="button"
          class="ntf-chip"
          [class.on]="category() === c"
          (click)="category.set(c)"
        >
          {{ c }}
          <span>{{ categoryCount(c) }}</span>
        </button>
      }
    </div>
  }

  <div class="table-wrap ntf-table-wrap">
    <table class="ntf-table">
      <thead>
        <tr>
          <th>Case</th>
          <th>Message</th>
          <th>When</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (n of items(); track n.id; let i = $index) {
          <tr [class.ntf-stripe]="i % 2 === 1" [class.ntf-is-unread]="!n.read">
            <td>
              <strong>{{ n.grievanceRef || '—' }}</strong>
            </td>
            <td>
              <div class="ntf-msg">{{ n.body }}</div>
              @if (guidance(n); as guide) {
                <div class="ntf-next">
                  <strong>Next step:</strong> {{ guide.nextStep }}
                </div>
              }
            </td>
            <td class="ntf-when">{{ n.at | date: 'd MMM y, HH:mm' }}</td>
            <td>
              @if (n.read) {
                <span class="ntf-read">Read</span>
              } @else {
                <span class="ntf-new">Unread</span>
              }
            </td>
            <td class="ntf-acts">
              @if (!n.read) {
                <button type="button" class="ntf-act" (click)="markRead(n.id)">Mark read</button>
              }
              @if (guidance(n); as guide) {
                <button type="button" class="ntf-act primary" (click)="openNextStep(n)">
                  {{ guide.actionLabel }} →
                </button>
              }
              <button type="button" class="ntf-act danger" (click)="remove(n.id)">Delete</button>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="5" class="ntf-empty">No notifications.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</section>
